import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import sumBy from 'lodash/sumBy';

import { formatMoney } from '../../shared/format';

import Calendar from '../../shared/calendar/main';
import Filters from '../../shared/filters/main';
import Table from '../../shared/new-table/main';

import wrapMain from '../wrap-main';

import Form from './form/main';

import table from './table-initial-data';

import { selectors, actions } from './';

import './index.less';

function Main({ intl, filters, calendar, data, updateById, removeById, ...props }) {
	return (
		<div className='marketing-funnel-activity'>
			<div className='marketing-funnel-activity-actions'>
				<div className='marketing-funnel-activity-filters clearfix'>
					<Filters
						intl={intl} {...filters} filters={filters} // for crutch support
					/>
				</div>
				<Calendar
					intl={intl}
					{...calendar}
					onInit={calendar.calendarInit}
					onToggle={calendar.calendarToggle}
					onChange={calendar.calendarChange}
					onApply={calendar.calendarApply}
				/>
				<button
					className='ui-btn ui-btn-primary'
					onClick={props.apply}
				>
					{intl('Apply')}
				</button>
				<button
					className='ui-btn ui-btn-secondary ui-icon-clear'
					onClick={props.clear}
				/>
			</div>

			<Form />

			<div className='marketing-funnel-activity-table-wrapper'>
				<Table
					payload={{ updateById, removeById }}
					table={table}
					rows={data || []}
				/>
			</div>

			<div className='marketing-funnel-activity-total-price'>
				Total price: {formatMoney(sumBy(data, 'price'))}
			</div>
		</div>
	);
}

function mapStateToProps(state) {
	return {
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		data: selectors.select(state, 'data'),
		// -----------------------------------------
		filters: selectors.getFilters(state),
		calendar: selectors.getCalendar(state)
	};
}

function mapDispatchToProps(dispatch) {
	return {
		...bindActionCreators(actions.own, dispatch),
		apply: () => dispatch(actions.apply()),
		clear: () => dispatch(actions.clear()),
		filters: bindActionCreators(actions.filters, dispatch),
		calendar: bindActionCreators(actions.calendar, dispatch)
	};
}

function mergeProps(stateProps, dispatchProps, ownProps) {
	return {
		...ownProps,
		...stateProps,
		...dispatchProps,
		filters: {
			...stateProps.filters,
			...dispatchProps.filters
		},
		calendar: {
			...stateProps.calendar,
			...dispatchProps.calendar
		}
	};
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(wrapMain(Main));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-funnel/activity/main.js